import { GetterTree } from 'vuex';
import { ItemState, RootState } from '../types';

export const getters: GetterTree<ItemState, RootState> = {
	getSelectedItem(state): MenuItem|object {
		return state.selectedItem;
	}
};